import React from "react";

type NavigationItem = {
  id: string;
  label: string;
};

type SidebarNavigationProps = {
  items: NavigationItem[];
};

const SidebarNavigation: React.FC<SidebarNavigationProps> = ({ items }) => (
  <div className="contact-box__right">
    <ul className="sidebar-list js-scroll">
      {items.map((item, index) => (
        <li key={item.id} className={`sidebar-list__item ${index === 0 ? "active" : ""}`}>
          <a href={`#${item.id}`} className={index === 0 ? "active" : ""}>{item.label}</a>
        </li>
      ))}
    </ul>
  </div>
);

export default SidebarNavigation;